<!-- TEMPLATE -->
<template>
    <div class='product-details'>
      <dean-two-column-layout :title="headerTitle">
      <dean-section-title-remove-restore
          v-if="$route.name === 'standingData.products.edit'"
          slot="title-items"
          :is-removed="isDeleted"
          text-remove="Verwijderen" :remove-icon="trashIcon" @remove="deleteProduct"
          text-restore="Herstellen" :restore-icon="lockOpenIcon" @restore="restoreProduct"
      >
      </dean-section-title-remove-restore>
        <dean-section-title-item
                :icon="saveIcon"
                slot="title-items"
                :content="true"
                :large="true"
                @click.native="processProduct"
        >
          Opslaan
        </dean-section-title-item>
        <div class="column" slot="left">
          <dean-form-row id="code" label="Code" v-model="data.code" :requiredField="true"
                         :text="true" :warning="$v.data.code.$error" @focus="$v.data.code.$touch()"></dean-form-row>
          <dean-form-row id="privateName" label="Omschrijving" v-model="data.privateName" :requiredField="true"
                         :text="true" :warning="$v.data.privateName.$error" @focus="$v.data.privateName.$touch()"></dean-form-row>
          <dean-form-row id="publicName" label="Omschrijving op factuur" v-model="data.publicName" :requiredField="true"
                         :text="true" :warning="$v.data.publicName.$error" @focus="$v.data.publicName.$touch()"></dean-form-row>
          <dean-form-row id="quoteName" label="Omschrijving op offerte" v-model="data.quoteName" :requiredField="true"
                         :text="true" :warning="$v.data.quoteName.$error" @focus="$v.data.quoteName.$touch()"></dean-form-row>
          <dean-select-form-row id="service" label="Dienst" placeholder="kies een dienst"
                                :clearable="true"
                                :value="currentlySelectedOption(data.service, productSelectOptions.services)"
                                :options="productSelectOptions.services"
                                @input="valueChanged($event, 'service')"></dean-select-form-row>
          <dean-multi-select-form-row id="provisioning diensten" key="provisioning-diensten" label="Provisioning Diensten" placeholder="kies provisioning diensten"
                                      :multiple="true" :options="availableProvisioningServicesList" :value="selectedProvisioningServicesList"
                                      @select="addProvisioningService" @remove="removeProvisioningService"/>

          <dean-input-switch-form-row id="main" label="Hoofdproduct" :value="data.main"
                                      @checked="valueChanged($event, 'main')"></dean-input-switch-form-row>
          <dean-select-form-row id="odidoProduct" label="Odido Producten" placeholder="kies een producten"
                                :clearable="true"
                                :value="currentlySelectedOption(data.odidoProductUuid, productSelectOptions.odidoProducts)"
                                :options="productSelectOptions.odidoProducts"
                                @input="valueChanged($event, 'odidoProductUuid')"></dean-select-form-row>
          <dean-select-form-row id="kpnProduct" label="KPN Producten" placeholder="kies een producten"
                                :clearable="true"
                                :value="currentlySelectedOption(data.kpnProductUuid, productSelectOptions.kpnProducts)"
                                :options="productSelectOptions.kpnProducts"
                                @input="valueChanged($event, 'kpnProductUuid')"></dean-select-form-row>
          <dean-select-form-row id="productGroup" label="Productgroep" placeholder="kies een productgroep"
                                :clearable="true"
                                :value="currentlySelectedOption(data.productGroup, productSelectOptions.productGroups)"
                                :options="productSelectOptions.productGroups"
                                @input="valueChanged($event, 'productGroup')"></dean-select-form-row>
          <dean-select-form-row id="productSubGroup" label="Product subgroep" placeholder="kies een subgroep"
                                :clearable="true"
                                :value="currentlySelectedOption(data.productSubGroup, productSelectOptions.productSubGroups)"
                                :options="productSelectOptions.productSubGroups"
                                @input="valueChanged($event, 'productSubGroup')"></dean-select-form-row>
          <dean-select-form-row id="productClass" label="Product klasse" placeholder="kies een klasse"
                                :clearable="true"
                                :value="currentlySelectedOption(data.productClass, productSelectOptions.productClass)"
                                :options="productSelectOptions.productClass"
                                @input="valueChanged($event, 'productClass')"></dean-select-form-row>
          <dean-select-form-row id="recurringCommissionGroup" label="Commissiegroep"
                                placeholder="kies een commissiegroep"
                                :requiredField="true"
                                :clearable="true"
                                :value="currentlySelectedOption(data.recurringCommissionGroup, productSelectOptions.recurringCommissionGroups)"
                                :options="productSelectOptions.recurringCommissionGroups"
                                @input="valueChanged($event, 'recurringCommissionGroup')"></dean-select-form-row>
          <dean-select-form-row id="vatCode" label="BTW-code" placeholder="kies een BTW-code"
                                :clearable="true"
                                :value="currentlySelectedOption(data.vatCode, productSelectOptions.vatCode)"
                                :options="productSelectOptions.vatCode"
                                @input="valueChanged($event, 'vatCode')"></dean-select-form-row>
          <dean-form-row id="minimum" label="Minimaal aantal" :requiredField="true" v-model="data.minimum"
                         :number="true" :warning="$v.data.minimum.$error" @focus="$v.data.minimum.$touch()"></dean-form-row>
          <dean-form-row id="maximum" label="Maximum aantal" v-model="data.maximum" :number="true"></dean-form-row>
          <dean-form-row id="default" label="Geadviseerd aantal" v-model="data.default" :number="true"
                         min="0"></dean-form-row>
        </div>
        <div class="column" slot="right">
          <dean-select-form-row id="parentProduct" label="Bovenliggend product" placeholder="kies een bovenliggend product"
                                :clearable="true"
                                :value="currentlySelectedOption(data.parentProduct, productSelectOptions.parentProducts)"
                                :options="productSelectOptions.parentProducts"
                                @input="valueChanged($event, 'parentProduct')"></dean-select-form-row>
          <dean-select-form-row id="mode" label="Productmodus" placeholder="kies een productmodus"
                                :value="data.mode"
                                :clearable="true"
                                :options="productSelectOptions.mode"
                                @input="valueChanged($event, 'mode')"></dean-select-form-row>
          <dean-form-row id="startdate" label="Begindatum" type="date" :requiredField="true"
                         v-model="data.startDate" :warning="$v.data.startDate.$error" @focus="$v.data.startDate.$touch()"></dean-form-row>
          <dean-form-row id="endDate" label="Einddatum" type="date" :requiredField="true"
                         v-model="data.endDate" :warning="$v.data.endDate.$error" @focus="$v.data.endDate.$touch()"></dean-form-row>
          <dean-form-row id="order" label="Order" :requiredField="true" v-model="data.order"
                         :number="true" :warning="$v.data.order.$error" @focus="$v.data.order.$touch()"></dean-form-row>
          <dean-form-row id="tags" label="Tags" v-model="data.tags"></dean-form-row>
          <dean-nullable-switch-form-row id="ownsAgreement" label="Heeft klantrelatie"
                                         v-model="data.ownsAgreement"></dean-nullable-switch-form-row>
          <dean-nullable-switch-form-row id="billsCustomer" label="Factureert klanten"
                                         v-model="data.billsCustomer"></dean-nullable-switch-form-row>
          <dean-nullable-switch-form-row id="suppliesHardware" label="Levert hardware"
                                         v-model="data.suppliesHardware"></dean-nullable-switch-form-row>
          <dean-nullable-switch-form-row id="providesSupport" label="Levert support"
                                         v-model="data.providesSupport"></dean-nullable-switch-form-row>
          <dean-nullable-switch-form-row id="managesDelivery" label="Beheert levering"
                                         v-model="data.managesDelivery"></dean-nullable-switch-form-row>
          <dean-nullable-switch-form-row id="monitorsDelivery" label="Volgt levering"
                                         v-model="data.monitorsDelivery"></dean-nullable-switch-form-row>
          <dean-input-switch-form-row id="isPbxBundle" label="PBX Bundle"
                                      :value="data.isPbxBundle"
                                      @checked="valueChanged($event, 'isPbxBundle')"></dean-input-switch-form-row>
        </div>
      </dean-two-column-layout>
    </div>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import { Vue, Component } from 'vue-property-decorator';

  // COMPONENTS
  import {
    deanSectionTitle,
    deanSectionTitleItem,
    deanInputSelectTime,
    lockOpenIcon,
    trashIcon,
    saveIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import DeanNullableSwitchFormRow from '@/components/deanComponents/deanNullableSwitchFormRow.vue';
  import DeanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required, minValue} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import DeanMultiSelectFormRow from "@/components/deanComponents/deanMultiSelectFormRow.vue";

  @Component({
    components: {
      saveIcon,
      lockOpenIcon,
      trashIcon,
      DeanSelectFormRow,
      DeanFormRow,
      DeanTwoColumnLayout,
      DeanNullableSwitchFormRow,
      DeanInputSwitchFormRow,
      deanSectionTitle,
      deanSectionTitleItem,
      deanInputSelectTime,
      deanSectionTitleRemoveRestore,
      DeanMultiSelectFormRow,
    },
    mixins: [validationMixin],
  })

  export default class Details extends Vue {

    // DATA
    public data: any = {
      service: '',
      odidoProductUuid: '',
      kpnProductUuid: '',
      productGroup: '',
      productSubGroup: '',
      productClass: '',
      recurringCommissionGroup: '',
      vatCode: '',
      parentProduct: '',
      provisioningServices: [],
      main: false,
      isPbxBundle: false,
    };
    public productSelectOptions = {
      services: [],
      productGroups: [],
      productSubGroups: [],
      productClass: [],
      recurringCommissionGroups: [],
      vatCode: [],
      odidoProducts: [],
      kpnProducts: [],
      parentProducts: [],
      mode: this.productModesList,
    };

    public provisioningServices: Array<{
      value: string,
      label: string,
    }> = [];
    public availableProvisioningServices: Array<{
      value: string,
      label: string,
    }> = [];
    public selectedProvisioningServices: Array<{
      value: string,
      label: string,
    }> = [];

    public sideMenuItems: any = [];
    public productName = '';
    public saveIcon: object = saveIcon;
    public lockOpenIcon: object = lockOpenIcon;
    public trashIcon: object = trashIcon;
    public isDeleted: boolean = false;

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          code: {required},
          privateName: {required},
          publicName: {required},
          recurringCommissionGroup: {required},
          quoteName: {required},
          minimum: {required, minValue: minValue(0)},
          startDate: {required},
          endDate: {required},
          order: {required, minValue: minValue(0)},
        },
      };
    }

    get sideMenu(): object {
      return {
        content: {
          title: {
            text: 'Product ' + this?.productName ?? '',
          },
          type: 'themed',
          sections: {
            backToProducts: {
              items: {
                products: {
                  title: 'Terug naar producten',
                  name: 'standingData.products',
                },
              },
            },
            filters: {
              title: 'Prijs plan',
              items: this.sideMenuItems,
            },
          },
        },
      };
    }

    get productModesList() {
      return [
        {value: 'restrict', label: 'restrict'},
        {value: 'multiply', label: 'multiply'},
        {value: 'subtract', label: 'subtract'},
      ];
    }

    get headerTitle(): string {
      return (this.$route.params.id !== undefined) ? 'Product wijzigen' : 'Product toevoegen';
    }

    public currentlySelectedOption(value: any, options: any) {
      if (value !== null) {
        const foundKey = Object.keys(options).find((key) => options[key].value === value);
        return foundKey != null ? options[foundKey] : null;
      }

      return null;
    }

    public valueChanged(field: any, id: any) {
      this.data[id] = field.value;

    }

    public mounted() {
      deanDialogBus.$on('productStatusChange', () => {
        this.$router.push({name: 'standingData.products'});
      });
    }

    public destroyed() {
      deanDialogBus.$off('productStatusChange');
    }

    public created() {
      this.$store.dispatch('setLoadOverlay', true);

      if (this.$route?.params?.id) {
        this.$store
        .dispatch('requestProduct', {id: this.$route.params.id})
        .then(
          (productResponse: any) => {
            this.data = productResponse.data;
            this.productName = productResponse.data.publicName;
            this.isDeleted = Boolean(productResponse.data.deleted);

            this.selectedProvisioningServices = productResponse.data.provisioningServices.map((provisioningService: any) => {
              return {
                value: provisioningService.identifier,
                label: provisioningService.name,
              };
            });
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        );
      }

      this.$store
          .dispatch('requestProvisioningServices')
          .then(
              (response: any) => {
                this.provisioningServices = response.data.map((provisioningService: any) => {
                  return {
                    value: provisioningService.identifier,
                    label: provisioningService.name,
                  };
                });
              },
              (error: any) => {
                this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
              },
          );

      this.buildSideMenu();
      this.fetchOptionsForSelectFields();
    }

    public fetchOptionsForSelectFields() {
      this.$store
      .dispatch('requestGroups', {type: 'service'})
      .then(
        (services: any) => {
          this.productSelectOptions.services = services.data.data.map((group: any) => {
              return {
                label: group.name,
                value: group.id,
              };
          });
          return this.$store.dispatch('requestGroups', {type: 'productSubGroup'});
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (productSubGroups: any) => {
          this.productSelectOptions.productSubGroups = productSubGroups.data.data.map((psg: any) => {
              return {
                label: psg.name,
                value: psg.id,
              };
          });
          return this.$store.dispatch('requestGroups', {type: 'productGroup'});
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (productGroups: any) => {
          this.productSelectOptions.productGroups = productGroups.data.data.map((pg: any) => {
              return {
                label: pg.name,
                value: pg.id,
              };
          });
          return this.$store.dispatch('requestGroups', {type: 'productClass'});
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (productClasses: any) => {
          this.productSelectOptions.productClass = productClasses.data.data.map((pc: any) => {
              return {
                label: pc.name,
                value: pc.id,
              };
          });
          return this.$store.dispatch('requestGroups', {type: 'recurringCommissionGroup'});
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (recurringCommissionGroups: any) => {
          this.productSelectOptions.recurringCommissionGroups = recurringCommissionGroups.data.data.map((rcg: any) => {
              return {
                label: rcg.name,
                value: rcg.id,
              };
          });
          return this.$store.dispatch('requestProducts', {status: 'active'});
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (parentProducts: any) => {
          this.productSelectOptions.parentProducts = parentProducts.data.data.map((pp: any) => {
              return {
                label: pp.privateName,
                value: pp.id,
              };
          });
          return this.$store.dispatch('requestVatCodes');
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
        (vatCodes: any) => {
          this.productSelectOptions.vatCode = vatCodes.data.data.map((vc: any) => {
              return {
                label: vc.description,
                value: vc.id,
              };
          });

          return this.$store.dispatch('requestOdidoProducts');
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .then(
          (odidoProducts: any) => {
            this.productSelectOptions.odidoProducts = odidoProducts.data.map((op: any) => {
              return {
                label: op.name,
                value: op.uuid,
              };
            });
            return this.$store.dispatch('requestKpnProducts');
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
      )
      .then(
          (kpnProducts: any) => {
            this.productSelectOptions.kpnProducts = kpnProducts.data.map((kp: any) => {
              return {
                label: kp.name,
                value: kp.uuid,
              };
            });
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
      )
      .finally(
        () => {
          this.$store.dispatch('updateSideMenu', this.sideMenu);
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public buildSideMenu() {
      this.$store.dispatch('requestPricePlans')
      .then(
        (pricePlans: any) => {
          this.sideMenuItems = pricePlans.data.data
            .filter((pp: any) => pp.startDate !== null)
            .map((pp: any) => {
              const pricePlanTitle = pp.name +
              (pp?.startDate?.split('-')[0] ? ' (' + pp?.startDate?.split('-')[0] + ' - ' : '') +
              (pp.endDate ? pp.endDate + ')' :  '');

              return {
                title: pricePlanTitle,
                name: 'standingData.pricePlan.entries.edit',
                params: {
                  id: pp.id,
                  ppId: pp.partnerAgreementTypes[0].id,
                  startDate: pp.startDate,
                  endDate: pp.endDate,
                },
              };
            });

          this.sideMenuItems.push({title: 'termijnen', name: 'standingData.productTerms'});
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      );
    }

    public deleteProduct() {
      deanDialogBus.$emit('open', 'ProductDeleteDialog', {
        id: this.$route.params.id,
      });
    }

    public restoreProduct() {
      deanDialogBus.$emit('open', 'ProductDeleteDialog', {
        id: this.$route.params.id,
        state: 'restoring',
      });
    }

    get availableProvisioningServicesList() {
      return this.availableProvisioningServices;
    }

    get selectedProvisioningServicesList() {
      this.updateAvailablePrivileges();
      return this.selectedProvisioningServices;
    }

    public addProvisioningService(field: any) {
      this.selectedProvisioningServices.push(field);
      this.updateAvailablePrivileges();
    }

    public removeProvisioningService(field: any) {
      this.selectedProvisioningServices = this.selectedProvisioningServices.filter((provisioningService: any) => {
        if (provisioningService.value !== field.value) {
          return provisioningService;
        }
      });
      this.updateAvailablePrivileges();
    }

    public updateAvailablePrivileges() {
      if (this.selectedProvisioningServices.length <= 0) {
        this.availableProvisioningServices = this.provisioningServices;
        return;
      }

      const selectedProvisioningServices: any[] = [];

      this.selectedProvisioningServices.forEach((provisioningService: any) => {
        selectedProvisioningServices[provisioningService.value] = provisioningService.label;
      });

      this.availableProvisioningServices = this.provisioningServices.filter((provisioningService: any) => {
        if (selectedProvisioningServices[provisioningService.value] === undefined) {
          return provisioningService;
        }
      });
    }

    public processProduct() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        this.data.provisioningServices = this.selectedProvisioningServices;

        this.$store.dispatch('processProduct', {id: this.$route.params.id, data: this.data}).then(
          (response) => {
            this.$toast({
                icon: saveIcon,
                text: 'Product opgeslagen',
                theme: 'success',
            });
            this.$store.dispatch('setLoadOverlay', false);
          }, (error) => {
            this.$store.dispatch('setLoadOverlay', false);
          },
        );
      } else {
        this.$toast(createNotification(this.$v));
      }
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

</style>
